import { createStore } from "vuex";

const savePlaylist = (playlist) => {

    return fetch("/api/playlist/", {
        method: "POST", 
        body: JSON.stringify(playlist),
        headers: {
            "content-type": "application/json"
        }
    })
}

const store = createStore({
    state: {
        open: false,
        closed: true,
        modal: null,
        loading: false,
        error: false,
        message: ""
    },
    mutations: {
        OPEN (state) {
            if (state.modal){
                state.modal.show();
                state.open = true;
                state.closed = !state.open;
            }
        },
        CLOSE (state) {
            if (state.modal){
                state.modal.hide()
                state.closed = true;
                state.open = !state.closed;
                state.error = false;
                state.message = ""
            }
        },
        SAVED(state){
            state.message = "Playlist Saved"
            state.error = false
        },
        ERROR(state, response) {
            state.message = response.message
            state.error = true
        }
    },
    actions: {
        open(context) {
            context.commit("OPEN")
        },
        close(context) {
            context.state.text = "";
            context.commit("CLOSE")
        },
        async save(context, playlist) {
            let response = await savePlaylist(playlist)
            if (response.status == 200) {
                context.commit("SAVED")
            } else {
                context.commit("ERROR", await response.json()) 
            }
        },
        error(context, message){
            context.commit("ERROR", message) 
        }
    }
})

export default store;